import { Popover, PopoverContent, PopoverTrigger } from 'cpool-components/general/Popover';
import { useTranslation } from 'react-i18next';
import { LuChevronDown } from 'react-icons/lu';

import { ArchiveChatMenuItem } from './ArchiveChatMenuItem';
import { cn } from '~/utils/cnTailwind';

type Props = {
    chatId: string;
    resolved: boolean;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    className?: string;
};

export const ChatListItemMenu = ({ chatId, className, onOpenChange, open, resolved }: Props) => {
    const { t } = useTranslation();

    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    aria-label={t('WHATSAPP_CHAT.LIST.ITEM_MENU_LABEL')}
                    className={cn(
                        'flex size-5 items-center justify-center rounded border border-outline-light bg-white text-midnight',
                        className,
                    )}
                >
                    <LuChevronDown className="size-4" />
                </button>
            </PopoverTrigger>
            <PopoverContent side="bottom" align="end" sideOffset={4} className="w-56 p-1">
                <ArchiveChatMenuItem chatId={chatId} resolved={resolved} onSelect={() => onOpenChange(false)} />
            </PopoverContent>
        </Popover>
    );
};
